<template>
	<div>

		<tableBox  :url="'/Flat/SelEthicalChange'"  :ifState="true" :ifScreen="true" :ifSearch="true"  :columns="columns"></tableBox>
	</div>
</template>

<script>
	import tableBox from '../../../components/tableBox.vue'
	export default {
		name:'/core/reviewChange',
		components: {
			tableBox
		},
		data() {
			return {

				columns: [
					{
							title: '新增编号',
							dataIndex: 'slsum',
							key: 'slsum',
						},
						{
							title: '平台',
							key: 'labName',
							dataIndex: 'labName',
							scopedSlots:{
								customRender:'labNamez'
							},
							aligh:'center'
						},
					{
						title: '实验项目名称',
						dataIndex: 'lroom',
						key: 'lroom',
					},
					{
						title: '关联审查编号',
						dataIndex: 'lslnum',
						key: 'lslnum'

					},
					{
						title: '原批准文号',
						dataIndex: 'iacuc',
						key: 'iacuc'
					
					},
					{
						title: '新增类型',
						dataIndex: 'type',
						key: 'type',
						scopedSlots: {
							customRender: 'type'
						},
						width:'250px'
					
					},
					{
						title: 'PI',
						key: 'tutorName',
						dataIndex: 'tutorName',
					},
					{
						title: '申请时间',
						key: 'createTime',
						dataIndex: 'createTime',

					},
					{
						title: '审核记录',
						key: 'state',
						dataIndex: 'state',
						scopedSlots: {
							customRender: 'examines'
						},
						aligh:'center'
					},
					{
						title: '状态',
						key: 'state',
						dataIndex: 'state',
						scopedSlots: {
							customRender: 'state3'
						}
					},
					{
						title: '操作',
						dataIndex: 'reviewChangeOperation',
						scopedSlots: {
							customRender: 'reviewChangeOperation'
						},
						width:180
					},
				],
				
			}
		}
	};
</script>

<style>
</style>
